import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, useBreakpointValue, useStyleConfig} from '@chakra-ui/react'
import {Controller, Navigation, Pagination, Keyboard} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/react'
import {ChevronRight, ChevronLeft} from '../../icons'
import {ContentSliderTile} from './content-slider-tile'

export const ContentSlider = ({
    title = '',
    variant = "Blue De'Longhi",
    contentSliderGroup = [],
}) => {
    let styleVariant = 'default'

    switch (variant) {
        case 'Black':
            styleVariant = 'black'
            break
        case 'Light Grey':
            styleVariant = 'grey'
            break
    }

    const componentUniqueKey = title.replaceAll(/ /g, '-').toLowerCase()

    const isMobile = useBreakpointValue({base: true, md: false})

    const swiperStyles = useStyleConfig('Swiper')
    const styles = useStyleConfig('ContentSlider', {variant: styleVariant})

    return (
        <Box data-testid="content-slider" {...styles.container}>
            <Box __css={{...swiperStyles, ...styles.content}} display={{base: 'block', xl: 'none'}}>
                {contentSliderGroup && contentSliderGroup?.length > 0 && (
                    <Swiper
                        className={'cs-swiper-mobile'}
                        key={`cs-mobile-swiper-controller-${componentUniqueKey}`}
                        modules={[Controller, Keyboard, Pagination]}
                        centeredSlides={true}
                        slidesPerView={1}
                        pagination={{
                            clickable: true,
                            el: `.slider-pagination-mobile-${componentUniqueKey}`,
                            renderBullet: (index, className) =>
                                `<span class="${className}" id="pag-tab-${index}">${contentSliderGroup[index].textblock?.label}</span>`,
                        }}
                        onSlideChangeTransitionStart={(swiper) => {
                            if (isMobile) {
                                document.getElementById('mobile-pagination-container').scrollLeft =
                                    document.getElementById(
                                        `pag-tab-${swiper.activeIndex}`,
                                    ).offsetLeft
                            }
                        }}
                    >
                        {contentSliderGroup.map((tile, tIndex) => (
                            <SwiperSlide key={`content-slider-tile-${tIndex}`} {...styles.slide}>
                                <ContentSliderTile
                                    image={tile?.image}
                                    textblock={tile?.textblock}
                                    styleVariant={styleVariant}
                                />
                            </SwiperSlide>
                        ))}
                        <Box id="mobile-pagination-container">
                            <Flex
                                className={`slider-pagination-mobile-${componentUniqueKey}`}
                                {...styles.mobilepagination}
                            />
                        </Box>
                    </Swiper>
                )}
            </Box>
            <Box __css={{...swiperStyles, ...styles.content}} display={{base: 'none', xl: 'block'}}>
                {contentSliderGroup && contentSliderGroup?.length > 0 && (
                    <Swiper
                        className={'cs-swiper-desktop'}
                        key={`cs-swiper-${componentUniqueKey}`}
                        modules={[Controller, Navigation, Pagination, Keyboard]}
                        pagination={{
                            clickable: true,
                            el: `.slider-pagination-${componentUniqueKey}`,
                            renderBullet: (index, className) =>
                                `<span class="${className}">${contentSliderGroup[index].textblock?.label}</span>`,
                        }}
                        navigation={{
                            prevEl: `.swiper-button-prev-${componentUniqueKey}`,
                            nextEl: `.swiper-button-next-${componentUniqueKey}`,
                        }}
                        keyboard={{
                            enabled: true,
                        }}
                        loop={true}
                        centeredSlides={true}
                        slidesPerView={1.2}
                        maxBackfaceHiddenSlides={0}
                    >
                        {contentSliderGroup.map((tile, tIndex) => (
                            <SwiperSlide key={`content-slider-tile-${tIndex}`} {...styles.slide}>
                                <ContentSliderTile
                                    image={tile?.image}
                                    textblock={tile?.textblock}
                                    styleVariant={styleVariant}
                                />
                            </SwiperSlide>
                        ))}
                        <ChevronLeft
                            className={`swiper-button-prev swiper-button-prev-${componentUniqueKey}`}
                            aria-label="swiper button prev icon"
                            {...styles.chevronIcon}
                        />
                        <ChevronRight
                            className={`swiper-button-next swiper-button-next-${componentUniqueKey}`}
                            aria-label="swiper button next icon"
                            {...styles.chevronIcon}
                        />

                        <Flex
                            className={`slider-pagination-${componentUniqueKey}`}
                            {...styles.pagination}
                        />
                    </Swiper>
                )}
            </Box>
        </Box>
    )
}

ContentSlider.propTypes = {
    title: PropTypes.string,
    variant: PropTypes.string,
    contentSliderGroup: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.shape(),
            textblock: PropTypes.shape({
                label: PropTypes.string,
                label_paragraph: PropTypes.string,
                title: PropTypes.string,
                body_copy: PropTypes.string,
                cta: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
            }),
        }),
    ),
}
